import cn from 'clsx'

import React from 'react'
import type { Track } from 'types/track'
import { AUDIO_FILE, VIDEO_FILE } from '@disco/constants/FileTypes'
import { getFileTypeByExt } from '@disco/utils/file-utils'
import { listContainsOnlyOptimizedTracks } from '@disco/utils/tracks'
import SelectableTrack from './selectable-track'
type TSelectableTrack = Track & {
  isSelected?: boolean
  isOriginalFormatSelected?: boolean
}
export type Props = {
  className?: string
  items: Array<TSelectableTrack>
  onTrackSelect: (track: Track, index: number) => unknown
  onOriginalFormatSelect: (track: Track, index: number) => unknown
  playlistId?: number
  merge?: boolean
}

const TrackList = (props: Props): React.ReactElement<'div'> => {
  const {
    items,
    onTrackSelect,
    onOriginalFormatSelect,
    playlistId,
    merge,
    className,
  } = props
  // don't show checkboxes if all tracks contain only optimized versions
  const onlyOptimizedTracks = listContainsOnlyOptimizedTracks(
    items as any as Track[],
  )
  const listItemsClassName = cn('BulkEditor_ListItems', className)
  return (
    <div className={listItemsClassName}>
      {items.map((item, index) => {
        const fileType = getFileTypeByExt(item.ext)
        const showCheckboxes = Boolean(
          !onlyOptimizedTracks &&
            merge &&
            item.all_files &&
            (fileType === AUDIO_FILE || fileType === VIDEO_FILE),
        )
        return (
          <SelectableTrack
            key={index}
            track={item}
            index={index}
            selected={item.isSelected}
            originalFormatSelected={item.isOriginalFormatSelected}
            onSelect={onTrackSelect}
            onOriginalFormatSelect={onOriginalFormatSelect}
            playlistId={playlistId}
            displayFormatCheckboxes={showCheckboxes}
          />
        )
      })}
    </div>
  )
}

export default TrackList
